export default __webpack_public_path__ + "static/media/raincheck.f253c49a.gif";